module.exports = __webpack_public_path__ + "static/img/product05.875e6e87.jpg";